module.exports = __webpack_public_path__ + "static/media/404.e9eb09c6.svg";